/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* functie.ts
* 4-5-2020 - Jelmer Jellema - Spin in het Web B.V.
*/


import {Component} from '@angular/core';
import {Datatablescherm} from '../../abstracts/datatablescherm.class';
import {DatatableDef} from 'sihw-ng/datatable/datatable.component';

@Component({
  selector: 'scherm-functie',
  templateUrl: './functie.html',
  // styleUrls: ['./materieel.scss']
})
export class Functiescherm extends Datatablescherm {
  _starttitle = 'Functies';
  icon = 'fas fa-clipboard-list';
  editscherm = 'Functieedit';
  tableQuery = {
    table: 'functie'
  };

  //////////////////////////// tabledef
  public readonly tableDefinition: DatatableDef = {
    track: 'id',
    standaardsortering: {
      key: 'typenaam',
      richting: 1
    },
    velden: {
      kleur: {
        label: null, //expliciet geen label
        prop: 'kleur',
        type: 'string',
        filter: false, //expliciet geen filter
        html: true,
        format: (kleur) => {
          if (kleur) {
            return `<div class="text-center"><span class='kleur' style="background-color: ${kleur};"></span></div> `;
          }
          else {
            return ''
          }
        }
      },
      typenaam: {
        label: 'Functie',
        prop: 'naam',
        type: 'string'
      }
    }
  };

  //constructor ivm injection
  constructor() {
    super('debug');
  }
}
